import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { fetchBookBySlug } from "../lib/booksApi";
import BookFooter from "../components/BookFooter";
import CopyProtectionGuard from "../components/CopyProtectionGuard";
import BookPageViewer from "../components/BookPageViewer";
import LeadFormModal from "../components/LeadFormModal";

export default function BookReaderPage() {
  const { slug } = useParams();
  const [state, setState] = useState({ status: "loading", book: null });
  const [modalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    setState({ status: "loading", book: null });
    fetchBookBySlug(slug).then(({ data }) => {
      setState({ status: data ? "ready" : "not-found", book: data });
    });
  }, [slug]);

  useEffect(() => {
    if (state.book) {
      document.title = `Reading: ${state.book.title} — ${state.book.author_name}`;
    }
  }, [state.book]);

  if (state.status === "loading") return null;
  if (state.status === "not-found") {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <p className="text-zinc-600">Book not found.</p>
      </div>
    );
  }

  const book = state.book;

  return (
    <div className="relative min-h-screen overflow-hidden bg-gradient-to-b from-sky-50 to-white px-6 py-16 text-center sm:py-24">
      <CopyProtectionGuard />
      <div
        aria-hidden
        className="pointer-events-none absolute left-1/2 top-0 h-72 w-[36rem] -translate-x-1/2 rounded-full bg-sky-200/40 blur-3xl"
      />

      <div className="relative [-webkit-user-select:none] [user-select:none]">
        <h1 className="mx-auto max-w-4xl text-4xl font-black tracking-tight text-zinc-900 sm:text-6xl">
          {book.title.toUpperCase()}
        </h1>

        <div className="mt-6 inline-block rounded-full bg-amber-400 px-6 py-2 text-sm font-bold tracking-wide text-zinc-900 shadow-sm">
          {book.author_name.toUpperCase()}
        </div>
        <p className="mt-2 text-zinc-600">{book.author_title}</p>

        <div className="mx-auto mt-10 max-w-3xl">
          <BookPageViewer pdfUrl={book.pdf_url} />
        </div>

        <button
          type="button"
          onClick={() => setModalOpen(true)}
          className="font-heading mt-8 inline-flex items-center gap-2 rounded-xl bg-gradient-to-r from-sky-500 to-blue-600 px-7 py-3.5 text-base font-semibold text-white shadow-lg shadow-sky-500/25 transition-all duration-300 hover:-translate-y-0.5 hover:shadow-xl hover:shadow-sky-500/35"
        >
          DOWNLOAD PDF COPY
        </button>
      </div>

      <div className="relative mt-16">
        <BookFooter book={book} />
      </div>

      <LeadFormModal
        book={book}
        open={modalOpen}
        onClose={() => setModalOpen(false)}
      />
    </div>
  );
}
